import React from "react";
import { RevealHeading, MagneticButton } from "./Motion";
import { Blob, ScribbleCircle, Sparkle, Squiggle, StarBurst, BnGlyph, DashedArc } from "./Decorations";
import { scrollToId } from "./useLenis";

export const FinalCTA = () => {
    return (
        <section className="relative py-32 lg:py-44 overflow-hidden">
            {/* Gentle floating decorations */}
            <Blob color="#FF4FA3" className="absolute top-10 left-[6%] w-32 h-32 opacity-50 animate-float-slow"/>
            <ScribbleCircle color="#3D5BFF" className="absolute bottom-12 right-[8%] w-32 h-32 opacity-50 animate-float-fast"/>
            <Squiggle color="#FFD23F" className="absolute top-[20%] right-[12%] w-28 animate-float-slow"/>
            <StarBurst color="#2EE8B5" className="absolute bottom-[15%] left-[14%] w-12 h-12 animate-float-fast"/>
            <DashedArc color="#7B3FE4" className="absolute top-[40%] left-[18%] w-24 h-24 animate-spin-slow"/>
            <Sparkle color="#FF5B3E" className="absolute top-[18%] right-[18%] w-10 h-10 animate-float-fast"/>
            <BnGlyph glyph="♬" className="absolute right-[6%] top-[6%] text-[120px] lg:text-[180px] leading-none opacity-[0.08] select-none" color="#FF5B3E"/>

            <div className="relative mx-auto max-w-[1100px] px-5 sm:px-8 text-center">
                <RevealHeading as="h2" className="h-display text-[56px] sm:text-[88px] lg:text-[140px] xl:text-[156px] text-ink leading-[0.95]">
                    Ready to give your readers a <span className="italic-display text-coral">voice?</span>
                </RevealHeading>
                <p className="mt-8 max-w-[560px] mx-auto text-[17px] sm:text-[19px] text-ink-muted">
                    Set up takes 4 minutes. Your first audio ships in 30 seconds after that.
                </p>
                <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
                    <MagneticButton
                        data-testid="final-cta"
                        onClick={() => scrollToId("demo")}
                        className="group bg-ink hover:bg-coral text-cream-100 rounded-full px-8 py-5 text-[16px] sm:text-[17px] font-semibold inline-flex items-center gap-2.5 shadow-pill hover:shadow-coral transition-all"
                    >
                        Get started — it's free
                        <span className="transition-transform group-hover:translate-x-1">→</span>
                    </MagneticButton>
                    <span className="text-[13px] text-ink-muted">No credit card · Cancel anytime</span>
                </div>
            </div>
        </section>
    );
};
